import Vue from 'vue';

export interface ILink {
  name: string;
  leaves?: boolean;
  modules?: string[];
  lockModule?: string;
  icon?: string;
  show: boolean;
  unlock: boolean;
  subMenu?: ILink[];

  [key: string]: any;
}

export let Links: ILink[] = Vue.observable([
    {
      name: 'TPV',
      leaves: false,
      icon: 'mdi-monitor',
      show: false,
      unlock: false,
      link: '/requests',
      modules: ['orders'],
    },
    {
      name: 'card',
      icon: 'mdi-silverware-fork-knife',
      modules: ['products'],
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'categories',
          link: '/categories/list',
          modules: ['categories'],
          icon: 'mdi-shape',
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'products',
          link: '/products/list',
          modules: ['products'],
          icon: 'mdi-hamburger',
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'modifiers',
          link: '/modifiers/list',
          modules: ['products'],
          icon: 'mdi-playlist-edit',
          leaves: false,
          show: true,
          unlock: false,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'distribution',
      icon: 'mdi-table-picnic',
      modules: ['tables'],
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'tableMap',
          link: '/distribution',
          icon: 'mdi-table-picnic',
          modules: ['tables', 'zones'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'screens',
          link: '/screens/list',
          icon: 'mdi-monitor',
          modules: ['screens'],
          leaves: false,
          show: false,
          unlock: false,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'loyalty',
      icon: 'mdi-gift',
      modules: ['loyalty'],
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'awards',
          link: '/awards/list',
          icon: 'mdi-gift-outline',
          modules: ['awards'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'offers',
          link: '/offers/list',
          icon: 'mdi-offer',
          //icon: 'mdi-lock',
          modules: ['offers'],
          leaves: false,
          show: false,
          unlock: false,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'users',
      icon: 'mdi-account-group',
      modules: ['users'],
      leaves: true,
      openTab: false,
      subMenu: [
          {
              name: 'employees',
              link: '/employees/list',
              icon: 'mdi-account-group',
              modules: ['auth_system'],
              leaves: false,
              show: false,
              unlock: false,
          },
          {
              name: 'clients',
              link: '/clients/list',
              icon: 'mdi-account-key',
              modules: ['clients'],
              leaves: false,
              show: false,
              unlock: false,
          },
          {
              name: 'timeTracking',
              link: '/employees/time-tracking',
              icon: 'mdi-timer-edit',
              //icon: 'mdi-lock',
              modules: ['auth_system'],
              leaves: false,
              show: false,
              unlock: false,
          },
      ],
      show: false,
      unlock: false,
    },
    // {
    //   name: 'Roles',
    //   link: '/roles/list',
    //   icon: 'people',
    //   modules: 'auth_system',
    //   leaves: false,
    //   show: false,
    // },
    {
      name: 'printers',
      icon: 'mdi-printer',
      modules: ['printers'],
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'printers',
          link: '/printers/list',
          icon: 'mdi-printer',
          modules: ['printers'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'families',
          link: '/categories_families/list',
          icon: 'mdi-shape-outline',
          modules: ['families'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'cashiers',
          link: '/cashiers/list',
          icon: 'mdi-cash-100',
          modules: ['cashiers'],
          leaves: false,
          show: true,
          unlock: true,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'cashRegister',
      link: '/printers/box_report',
      icon: 'mdi-cash-register',
      modules: ['printers'],
      leaves: false,
      show: false,
      unlock: false,
    },
    {
      name: 'bookings',
      icon: 'mdi-calendar-month',
      modules: ['reservations'],
      lockModule: 'reservas',
      link: '/bookings',
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'bookings',
          link: '/bookings',
          icon: 'mdi-calendar-month',
          modules: ['reservations'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'shifts',
          link: '/shifts/list',
          icon: 'mdi-clock-time-eight-outline',
          modules: ['shifts'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'booking-options',
          link: '/bookings_options',
          icon: 'mdi-calendar-account-outline',
          modules: ['reservations'],
          leaves: false,
          show: false,
          unlock: false,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'reports',
      icon: 'mdi-file-multiple',
      modules: ['reports'],
      link: '/reports',
      leaves: false,
      show: true,
      unlock: true,
    },
    {
      name: 'settings',
      link: '/settings',
      icon: 'mdi-cog-outline',
      modules: ['settings'],
      leaves: false,
      show: false,
      unlock: false,
    },
    {
      name: 'stock',
      icon: 'mdi-warehouse',
      modules: ['stk'],
      lockModule: 'stock',
      link: '/stock',
      leaves: false,
      show: false,
      unlock: false,      
    },
  ])
;
